import { useMutation } from "@tanstack/react-query";
import { toastServerError } from "helpers";
import { ApiError, ApiServiceError } from "libs/api";
import { MutationOptions } from "libs/reactQuery";

import { InventoryManagerListItem } from "../../inventory.types";
import { requestUpdateInventoryManager } from "./updateInventoryManager.request";

const useUpdateInventoryManager = (
  options?: MutationOptions<InventoryManagerListItem, ApiServiceError<ApiError>>
) => {
  return useMutation({
    mutationFn: requestUpdateInventoryManager,
    onError: toastServerError,
    ...options
  });
};

export default useUpdateInventoryManager;
